<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #ac8400">Transaction</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #f2f2f2">
      <router-link to="/dashboard">Dashboard</router-link> /
      <b>Transaction</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <p>The page allow to view any redeem transaction.</p>

        <!-- Card -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">TRANSACTION</h4>

            <!-- Redeem -->
            <div class="table-responsive">
              <table
                id="redeem_tbl"
                class="display table table-striped table-bordered"
                style="width: 100%; text-align: center"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Products & Services</th>
                    <th>Price</th>
                    <th>Date</th>
                    <th>Redeemed By</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(transaction, index) in transactions"
                    v-bind:key="index"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ transaction.transaction_description }}</td>
                    <td>
                      <span v-if="transaction.price_redeemed == null">-</span>
                      <span v-else>{{ transaction.price_redeemed }}</span>
                    </td>
                    <td>
                      {{
                        transaction.transaction_created_at
                          | moment("Do MMMM YYYY, h:mm a")
                      }}
                    </td>
                    <td>
                      <span v-if="transaction.account_number == null">-</span>
                      <span v-else>{{ transaction.account_number }}</span>
                    </td>

                    <td>
                      <router-link
                        :to="redirect(transaction.transaction_id)"
                        class="btn btn-primary btn-rounded btn-block"
                        >View Details</router-link
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


    <script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "vendor-transactions",
  components: {},

  data() {
    return {
      transactions: [],
    };
  },

  methods: {
    loadTransactions() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/transaction", {
            headers: {
              Authorization: "Bearer " + token,
            },
          })
          .then((res) => {
            this.transactions = res.data.transactions;
          })
          .then(function () {
            $("#redeem_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: ["excel", "pdf"],
            });
          });
      }
    },

    loadData() {
      this.destroyDatatable();
      this.loadTransactions();
    },

    destroyDatatable() {
      $("#redeem_tbl").DataTable().destroy();
      //   $("#faq_inactive_tbl").DataTable().destroy();
    },

    redirect(id) {
      return "/transaction/summary/" + id;
    },
  },

  mounted() {
    this.loadData();
  },
};
</script>
